import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Truck, MapPin, Check, Lock } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';
import Button from './components/Button';

const Checkout = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        fullName: '', email: '', phone: '', address: '', city: '', state: '', pincode: '',
        paymentMethod: 'card', cardNumber: '', expiry: '', cvv: '',
    });

    const steps = [
        { id: 1, label: 'Shipping', icon: MapPin },
        { id: 2, label: 'Payment', icon: CreditCard },
        { id: 3, label: 'Review', icon: Check },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const orderItems = [
        { name: 'Banarasi Silk Saree', price: 12999, qty: 1, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=200' },
        { name: 'Designer Lehenga Set', price: 24500, qty: 1, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=200' },
    ];

    const subtotal = orderItems.reduce((s, item) => s + item.price * item.qty, 0);
    const shipping = 0;
    const total = subtotal + shipping;

    const inputClass = "w-full px-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A] bg-white";

    return (
        <div className="w-full min-h-screen bg-[#F0F7FA]" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24 pb-16">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-2xl md:text-3xl font-semibold text-[#1B4965] mb-8 pt-4">Checkout</h1>

                    {/* Steps */}
                    <div className="flex items-center justify-center mb-10">
                        {steps.map((step, idx) => (
                            <React.Fragment key={step.id}>
                                <div className="flex flex-col items-center">
                                    <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all ${
                                        currentStep >= step.id ? 'bg-[#1B4965] text-white' : 'bg-white text-[#6B7280] border border-[#E5E7EB]'
                                    }`}>
                                        {currentStep > step.id ? <Check className="w-4 h-4" /> : step.id}
                                    </div>
                                    <span className={`text-xs mt-2 ${currentStep >= step.id ? 'text-[#1B4965] font-medium' : 'text-[#6B7280]'}`}>{step.label}</span>
                                </div>
                                {idx < steps.length - 1 && (
                                    <div className={`flex-1 h-px mx-4 ${currentStep > step.id ? 'bg-[#1B4965]' : 'bg-[#E5E7EB]'}`} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-white p-6 rounded-sm border border-[#E5E7EB]">
                                {currentStep === 1 && (
                                    <div>
                                        <h2 className="text-lg font-semibold text-[#1B4965] mb-6">Shipping Information</h2>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div className="sm:col-span-2">
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Full Name</label>
                                                <input name="fullName" value={formData.fullName} onChange={handleInputChange} className={inputClass} placeholder="Enter your full name" />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Email</label>
                                                <input name="email" type="email" value={formData.email} onChange={handleInputChange} className={inputClass} placeholder="you@email.com" />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Phone</label>
                                                <input name="phone" value={formData.phone} onChange={handleInputChange} className={inputClass} placeholder="+91 98765 43210" />
                                            </div>
                                            <div className="sm:col-span-2">
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Address</label>
                                                <input name="address" value={formData.address} onChange={handleInputChange} className={inputClass} placeholder="Street address" />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">City</label>
                                                <input name="city" value={formData.city} onChange={handleInputChange} className={inputClass} placeholder="City" />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">State</label>
                                                <input name="state" value={formData.state} onChange={handleInputChange} className={inputClass} placeholder="State" />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Pincode</label>
                                                <input name="pincode" value={formData.pincode} onChange={handleInputChange} className={inputClass} placeholder="400001" />
                                            </div>
                                        </div>
                                        <div className="mt-6 flex justify-end">
                                            <Button variant="primary" size="lg" onClick={() => setCurrentStep(2)}>Continue to Payment</Button>
                                        </div>
                                    </div>
                                )}

                                {currentStep === 2 && (
                                    <div>
                                        <h2 className="text-lg font-semibold text-[#1B4965] mb-6">Payment Method</h2>
                                        <div className="space-y-3 mb-6">
                                            {[{ id: 'card', label: 'Credit / Debit Card' }, { id: 'upi', label: 'UPI Payment' }, { id: 'cod', label: 'Cash on Delivery' }].map((method) => (
                                                <label
                                                    key={method.id}
                                                    className={`flex items-center gap-3 p-4 border rounded-sm cursor-pointer transition-all ${
                                                        formData.paymentMethod === method.id ? 'border-[#1B4965] bg-[#F0F7FA]' : 'border-[#E5E7EB]'
                                                    }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="paymentMethod"
                                                        value={method.id}
                                                        checked={formData.paymentMethod === method.id}
                                                        onChange={handleInputChange}
                                                        className="accent-[#1B4965]"
                                                    />
                                                    <span className="text-sm font-medium text-[#1A1A1A]">{method.label}</span>
                                                </label>
                                            ))}
                                        </div>

                                        {formData.paymentMethod === 'card' && (
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Card Number</label>
                                                    <input name="cardNumber" value={formData.cardNumber} onChange={handleInputChange} className={inputClass} placeholder="1234 5678 9012 3456" />
                                                </div>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Expiry</label>
                                                        <input name="expiry" value={formData.expiry} onChange={handleInputChange} className={inputClass} placeholder="MM/YY" />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-medium text-[#6B7280] mb-1.5">CVV</label>
                                                        <input name="cvv" value={formData.cvv} onChange={handleInputChange} className={inputClass} placeholder="123" />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="mt-6 flex justify-between">
                                            <Button variant="outline" size="lg" onClick={() => setCurrentStep(1)}>Back</Button>
                                            <Button variant="primary" size="lg" onClick={() => setCurrentStep(3)}>Review Order</Button>
                                        </div>
                                    </div>
                                )}

                                {currentStep === 3 && (
                                    <div>
                                        <h2 className="text-lg font-semibold text-[#1B4965] mb-6">Order Review</h2>
                                        <div className="space-y-4 mb-6">
                                            {orderItems.map((item, i) => (
                                                <div key={i} className="flex gap-4 p-3 bg-[#F0F7FA] rounded-sm">
                                                    <img src={item.image} alt={item.name} className="w-16 h-20 object-cover rounded-sm" />
                                                    <div className="flex-1">
                                                        <p className="text-sm font-medium text-[#1A1A1A]">{item.name}</p>
                                                        <p className="text-xs text-[#6B7280]">Qty: {item.qty}</p>
                                                        <p className="text-sm font-semibold text-[#1B4965] mt-1">{'\u20B9'}{item.price.toLocaleString()}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="p-4 bg-[#F0F7FA] rounded-sm mb-6">
                                            <p className="text-sm font-medium text-[#1A1A1A] mb-2">Shipping to:</p>
                                            <p className="text-sm text-[#6B7280]">
                                                {formData.fullName || 'Name'}, {formData.address || 'Address'}, {formData.city || 'City'}, {formData.state || 'State'} - {formData.pincode || 'Pincode'}
                                            </p>
                                        </div>

                                        <div className="mt-6 flex justify-between">
                                            <Button variant="outline" size="lg" onClick={() => setCurrentStep(2)}>Back</Button>
                                            <Button variant="primary" size="lg" className="gap-2">
                                                <Lock className="w-4 h-4" /> Place Order - {'\u20B9'}{total.toLocaleString()}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Order Summary Sidebar */}
                        <div className="lg:col-span-1">
                            <div className="bg-white p-6 rounded-sm border border-[#E5E7EB] sticky top-24">
                                <h3 className="text-sm font-semibold text-[#1B4965] mb-4 uppercase tracking-wider">Order Summary</h3>
                                <div className="space-y-3 mb-4">
                                    {orderItems.map((item, i) => (
                                        <div key={i} className="flex justify-between text-sm">
                                            <span className="text-[#6B7280]">{item.name} x{item.qty}</span>
                                            <span className="text-[#1A1A1A] font-medium">{'\u20B9'}{(item.price * item.qty).toLocaleString()}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="pt-3 border-t border-[#E5E7EB] space-y-2">
                                    <div className="flex justify-between text-sm">
                                        <span className="text-[#6B7280]">Subtotal</span>
                                        <span className="text-[#1A1A1A]">{'\u20B9'}{subtotal.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between text-sm">
                                        <span className="text-[#6B7280]">Shipping</span>
                                        <span className="text-[#62B6CB] font-medium">Free</span>
                                    </div>
                                    <div className="pt-3 border-t border-[#E5E7EB] flex justify-between">
                                        <span className="font-semibold text-[#1A1A1A]">Total</span>
                                        <span className="text-lg font-bold text-[#1B4965]">{'\u20B9'}{total.toLocaleString()}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Checkout;
